export const TYPE_EXPAND = '$expand';
export const TYPE_SELECT = '$select';
export const TYPE_FILTER = '$filter';
